"use client";

import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface Props {
  children: React.ReactNode;
  topClass?: string;
}

const HIDE_THRESHOLD_PX = 80;
const MIN_DELTA_PX = 5;

export function ScrollAwareHeader({ children, topClass = "top-0" }: Props) {
  const [hidden, setHidden] = useState(false);
  const lastYRef = useRef(0);

  useEffect(() => {
    lastYRef.current = window.scrollY;

    function onScroll() {
      const currentY = window.scrollY;
      const delta = currentY - lastYRef.current;
      if (Math.abs(delta) < MIN_DELTA_PX) return;
      if (currentY < HIDE_THRESHOLD_PX) {
        setHidden(false);
        lastYRef.current = currentY;
        return;
      }
      setHidden(delta > 0);
      lastYRef.current = currentY;
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={cn("sticky z-40 transition-transform duration-300", topClass, hidden && "-translate-y-full")}>
      {children}
    </div>
  );
}
